import { push } from 'connected-react-router';
import { createMiddleware } from '../../../shared/redux';
import Routes from '../../router/routes.constants';
import { ROUTES as AUTH_ROUTES } from '../auth.constants';
import {
    CHECK_SIGN_UP_DATA_REQUEST_SUCCEEDED,
    isCompanySignUpDataComplete,
    isUserProfileSignUpDataComplete,
    isUserProfileTeamAdmin,
    setIsCompanySignUpDataComplete,
} from './check-sign-up-data.state';
import { acceptSignIn } from '../sign-in/sign-in.state';

const { COGNITO_APP_CLIENT_ID } = process.env;
const { TESS_ALLOWED_ORIGINS } = process.env;

export const checkSignUpDataMiddleware = createMiddleware({
    // eslint-disable-next-line complexity
    [CHECK_SIGN_UP_DATA_REQUEST_SUCCEEDED]: (state) => {
        const isUserProfileComplete = isUserProfileSignUpDataComplete(state);
        const isCompanyComplete = isCompanySignUpDataComplete(state);
        const isAdmin = isUserProfileTeamAdmin(state);

        if (!isUserProfileComplete && !isCompanyComplete && !isAdmin) {
            return [
                setIsCompanySignUpDataComplete({ isComplete: true }),
                push(AUTH_ROUTES.UPDATE_SIGN_UP_DATA),
            ];
        }
        if (!isUserProfileComplete || (isAdmin && !isCompanyComplete)) {
            return [
                push(AUTH_ROUTES.UPDATE_SIGN_UP_DATA),
            ];
        }

        if (isTessPagesCalling()) {
            return shareUserAuthenticationWithTessPages();
        }

        const landingRoute = getLandingRoute(state.router.location.pathname);
        return acceptSignIn({ landingRoute });
    },
});

function shareUserAuthenticationWithTessPages() {
    const cognitoPrefix = `CognitoIdentityServiceProvider.${COGNITO_APP_CLIENT_ID}`;
    const user = localStorage.getItem(`${cognitoPrefix}.LastAuthUser`);

    getTessPageCaller()?.postMessage(JSON.stringify({
        data: {
            user,
            idToken: localStorage.getItem(`${cognitoPrefix}.${user}.idToken`),
            accessToken: localStorage.getItem(`${cognitoPrefix}.${user}.accessToken`),
        },
        type: '@tess-pages/AUTH',
    }), '*');

    window.close();
}

export function isTessPagesCalling() {
    try {
        const pageCallerOrigin = new URL(document.referrer).origin;
        const isTessOrigin = TESS_ALLOWED_ORIGINS.split(',').includes(pageCallerOrigin);
        const isTessPageOpener = !!window?.opener;

        return isTessOrigin && (isTessPageIFrameCalling() || isTessPageOpener);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.log({ e });
        return false;
    }
}

function isTessPageIFrameCalling() {
    return window.parent !== window.self;
}

export function getTessPageCaller() {
    return isTessPageIFrameCalling() ? window?.parent : window?.opener;
}

function getLandingRoute(pathname) {
    return pathname === AUTH_ROUTES.SPLASH_SCREEN ? Routes.HOME : pathname;
}
